import React from "react";
import { useSettings } from "../lib/settings";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveLogoUrl(url) {
  if (!url) return "/atech-logo.png";
  // Admin-uploaded logo served from the backend — prefix absolute origin
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const Logo = ({ size = 32, withWordmark = true, className = "" }) => {
  const { settings } = useSettings();
  const src = resolveLogoUrl(settings?.logo_url);
  const practice = (settings?.practice_name || "A-Tech").split(" ")[0].toUpperCase();
  const portal = settings?.portal_name || "A-Tech Client Portal";
  const tagline = portal.toLowerCase().includes("client portal") ? "Client Portal" : portal;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt={settings?.practice_name || "A-Tech"}
        style={{ width: size, height: size }}
        className="object-contain select-none"
        draggable={false}
      />
      {withWordmark && (
        <div className="leading-tight">
          <div className="font-display text-[15px] tracking-tight text-[color:var(--atech-text)]">
            {practice}
          </div>
          <div className="text-[10px] tracking-[0.22em] uppercase text-[color:var(--atech-text-dim)]">
            {tagline}
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
